import HeroVideo from "../HeroVideo";
import Title from "../Title";
import Typo from "../Typo";
import {useRouter} from "next/router";
import localized from "../../locale/locales";

export default function SectionGymHeader() {
    const {locale} = useRouter();
    const lang = localized[locale].gym.header;

    return (
        <HeroVideo size="medium"
                   mobileVideo="/videos/hero/gym_mobile.mp4"
                   tabletVideo="/videos/hero/gym_tablet.mp4"
                   desktopVideo="/videos/hero/gym_desktop.mp4"
                   align="bottom"
        >
            <div className={`flex flex-col gap-4 max-w-[400px] pb-20`}>
                <header>
                    <Title Elem="h1">{lang.title}</Title>
                </header>
                <Typo>
                        <span className="md:hidden">
                            {lang.body.mobile}
                        </span>
                    <span className="hidden md:inline">
                            {lang.body.desktop}
                        </span>
                </Typo>
            </div>
        </HeroVideo>
    );
}
